import { useMutation } from "@/hooks/useApi";
import { createTestTestimonial } from "../api/testTestimonials.service.js";
import type { CreateTestTestimonialRequest } from "../api/testTestimonials.service.js";

export function useCreateTestTestimonial() {
  return useMutation((data: CreateTestTestimonialRequest) => createTestTestimonial(data));
}
